import { SidebarItem } from "../../Redux/Sidebar/sidebarSlice";
import { RxDashboard } from "react-icons/rx";
import { FiCalendar, FiSettings, FiVideo } from "react-icons/fi";
import { AiOutlineVideoCameraAdd } from "react-icons/ai";
import { RiSettings2Fill, RiUserSettingsLine } from "react-icons/ri";
import { BsPersonVideo2 } from "react-icons/bs";
import { IoAnalytics } from "react-icons/io5";
import { CgUserList } from "react-icons/cg";
import { MdManageAccounts } from "react-icons/md";

export const mainItems: SidebarItem[] = [
  // {
  //   label: "User Management",
  //   icon: RxDashboard,
  //   route: "/user-management",
  // },
  {
    label: "User Management",
    icon: MdManageAccounts,
    route: "/user-management",
    customerRequired: true,
  },
  {
    label: "License Overview",
    icon: CgUserList,
    route: "/license-overview",
    superOnly: true,
  },
  {
    label: "Settings",
    icon: RiSettings2Fill,
    route: "/settings",
  },
  
];

export const ldapItems: SidebarItem[] = [
  {
    label: "Connect",
    icon: FiVideo,
    showChildren: false,
    children: [
      {
        label: "Instant Meeting",
        icon: AiOutlineVideoCameraAdd,
        route: "/instant-meet",
      },
      {
        label: "Schedule Meeting",
        icon: FiCalendar,
        route: "/schedule",
      },
      {
        label: "Personal Rooms",
        icon: BsPersonVideo2,
        route: "/personal-rooms",
      },
      {
        label: "Analytics",
        icon: IoAnalytics,
        route: "/meeting-analytics",
      },
      {
        label: "Meet Settings",
        icon: FiSettings,
        route: "/meet-settings",
      },
    ],
  },
];
